module.exports = __webpack_public_path__ + "img/red-pin.96e12597.svg";